export default __webpack_public_path__ + "img/wyci.2f9cb2a3.png";